{
  "paymentLink": "https://nowpayments.io/payment/?iid=5632892689",
  "period": "1 YEAR",
  "badge": "",
  "price": "300",
  "styleType": "Red",
  "isMostPopular": true,
  "title": "1 YEAR ACCESS",
  "descriptionList": [
    "Access to Richard Swing Channel",
    "Access to Richard Scalping Channel",
    "Access to Richard Altcoin Channel",
    "All signals can be fully automated",
    "Highly active support from me"
  ],
  "id": "2"
}